module.exports = __webpack_public_path__ + "img/00 banner.1eea1a06.png";